/* global google */

import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import _debug from 'debug';
import { renderList, columnWidth } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import { geocodeString } from 'services/geocoding';
import { error } from 'plugins/toastr';
import AccountingCodesDetail from './components/AccountingCodesDetail';

const debug = _debug('app::accounting_codes');

require('plugins/are-you-sure');

export function list() {
  const from = '/pco-manager/customers';

  const rowClickedUrl = id => withReferer(`/pco-manager/customers/${id}`, from);
  const loadNextUrl = '/pco-manager/customers/range.json';

  renderList(rowClickedUrl, loadNextUrl, renderColumns, {
    rowHeight: 40,
  });
}

export function handleRestrictionsVisibility(inputName, segmentName) {
  const changeVisibility = () => {
    const checked = $(`input[name="${inputName}"]`)
      .parent()
      .checkbox('is checked');
    if (checked) {
      $(`div.${segmentName}`).show();
    } else {
      $(`div.${segmentName}`).hide();
    }
  };

  changeVisibility();

  $(`input[name="${inputName}"]`)
    .parent()
    .checkbox({
      onChecked: function() {
        changeVisibility();
      },
      onUnchecked: function() {
        changeVisibility();
      },
    });
}

export const handleInvoiceContactInputs = () => {
  const $cb = $('.invoice_contact_enabled.checkbox');
  const $fields = $('.invoice_contact div.inputs .field');
  const $inputs = $('.invoice_contact div.inputs input');
  const checked = $cb.hasClass('checked');

  $cb.checkbox({
    fireOnInit: true,
    onChecked: () => {
      $fields.removeClass('disabled');
      $inputs.attr('disabled', false);
    },
    onUnchecked: () => {
      $fields.addClass('disabled');
      $inputs.attr('disabled', true);
    },
  });
  if (checked) {
    $cb.checkbox('check');
  }
};

export const bindForm = () => {
  const root = document.getElementById('accounting_codes');

  const $companyForm = $('.companyForm');
  const $particularForm = $('.particularForm');
  const $switch = $('.ui.radio.checkbox.identity');

  $('#clientCode').on('change', evt => {
    const value = $(evt.target).val();

    const changeClientCode = $form =>
      $form.find('input[name="clientCode"]').val(value);

    changeClientCode($companyForm);
    changeClientCode($particularForm);
  });

  $('#accountingCode').on('change', evt => {
    const value = $(evt.target).val();

    const changeAccountingCode = $form =>
      $form.find('input[name="accountingCode"]').val(value);

    changeAccountingCode($companyForm);
    changeAccountingCode($particularForm);
  });

  const toggleForms = () => {
    $companyForm.toggle();
    $particularForm.toggle();
  };

  $switch.checkbox({
    onChange: () => toggleForms(),
  });

  handleRestrictionsVisibility('contact.has_own_address', 'contact-address');
  handleRestrictionsVisibility(
    'invoiceContact.has_own_address',
    'invoice-contact-address'
  );
  handleInvoiceContactInputs();

  if (root) {
    debug(`Rendering accounting codes for customer`);

    // Retrieving context data
    let lines = __INITIAL_DATA__;
    if (!lines) {
      lines = [];
    }
    lines.map(line => {
      if (line.id) {
        return line;
      } else {
        delete line.id;
        return line;
      }
    });

    ReactDOM.render(<AccountingCodesDetail lines={lines} />, root);
  }
  return null;
};

const enableEmptyFields = (...inputs) => {
  inputs.forEach(input => {
    const parent = input.parent().parent();
    if (!!input.val()) {
      parent.addClass('disabled');
    } else {
      parent.removeClass('disabled');
    }
  });
};

const fillGeocodedAddressForm = ($form, response) => {
  const $addressInput = $form.find('input[name="address.address"]');
  const $postalCodeInput = $form.find('input[name="address.postalCode"]');
  const $cityInput = $form.find('input[name="address.city"]');
  const $locationInput = $form.find('input[name="location"]');

  if ($addressInput && $addressInput.length) {
    $addressInput.val(response.address.address);
  }

  if ($postalCodeInput && $postalCodeInput.length) {
    $postalCodeInput.val(response.address.postal_code);
  }

  if ($cityInput && $cityInput.length) {
    $cityInput.val(response.address.city);
  }

  if ($locationInput && $locationInput.length && response.coordinates) {
    $locationInput.val(
      `${response.coordinates.lat},${response.coordinates.lng}`
    );
  }

  enableEmptyFields($addressInput, $postalCodeInput, $cityInput);
};

const fillGeocodedParticularAddressForm = ($form, response) => {
  const $addressInput = $form.find(
    'input[name="contact.contactAddress.address"]'
  );
  const $postalCodeInput = $form.find(
    'input[name="contact.contactAddress.postalCode"]'
  );
  const $cityInput = $form.find('input[name="contact.contactAddress.city"]');
  const $locationInput = $form.find('input[name="particular-location"]');

  if ($addressInput && $addressInput.length && response.address.address) {
    $addressInput.val(response.address.address);
  }

  if (
    $postalCodeInput &&
    $postalCodeInput.length &&
    response.address.postal_code
  ) {
    $postalCodeInput.val(response.address.postal_code);
  }

  if ($cityInput && $cityInput.length && response.address.city) {
    $cityInput.val(response.address.city);
  }

  if ($locationInput && $locationInput.length && response.coordinates) {
    $locationInput.val(
      `${response.coordinates.lat},${response.coordinates.lng}`
    );
  }

  enableEmptyFields($addressInput, $postalCodeInput, $cityInput);
};

export const bindCreationGeocoding = ($form, isParticular = false) => {
  const $geocodeButton = isParticular
    ? $form.find('button.particular-geocode')
    : $form.find('button.geocode');
  const $locationInput = isParticular
    ? $form.find('input[name="particular-geocode-search"]')
    : $form.find('input[name="geocode-search"]');
  const $customerMap = isParticular
    ? $('#particular-customer-map')
    : $('#customer-map');

  const onMapClick = (e, map) => {
    $geocodeButton.addClass('loading');
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const zoom = map.getZoom();

    geocodeString(lat + ',' + lng)
      .then(
        obj => {
          isParticular
            ? fillGeocodedParticularAddressForm($form, obj)
            : fillGeocodedAddressForm($form, obj);
          if (obj.formattedAddress) {
            $locationInput.val(obj.formattedAddress);
          }
          initMapFromLocation(
            obj.coordinates,
            onMapClick,
            zoom,
            false,
            $customerMap.attr('id')
          );
        },
        _ => error("Impossible de récupérer les informations d'adresse")
      )
      .then(_ => $geocodeButton.removeClass('loading'));
  };

  if (
    $geocodeButton &&
    $geocodeButton.length &&
    $locationInput &&
    $locationInput.length
  ) {
    // Handling geocoding

    $geocodeButton.off('click').on('click', evt => {
      evt.preventDefault();

      $geocodeButton.addClass('loading');
      geocodeString($locationInput.val())
        .then(
          obj => {
            isParticular
              ? fillGeocodedParticularAddressForm($form, obj)
              : fillGeocodedAddressForm($form, obj);
            initMapFromLocation(
              obj.coordinates,
              onMapClick,
              undefined,
              false,
              $customerMap.attr('id')
            );
          },
          _ => error("Impossible de récupérer les informations d'adresse")
        )
        .then(_ => $geocodeButton.removeClass('loading'));
    });
  }

  const initEmptyMap = () => {
    initMapFromLocation(
      {
        lat: 46.768545,
        lng: 2.518912,
      },
      onMapClick,
      5,
      true,
      $customerMap.attr('id')
    );
  };

  if (!navigator.geolocation) {
    initEmptyMap();
  } else {
    const locationFound = position => {
      initMapFromLocation(
        {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        },
        onMapClick,
        undefined,
        true,
        $customerMap.attr('id')
      );
    };

    navigator.geolocation.getCurrentPosition(locationFound, initEmptyMap);
  }
};

export const bindUpdateGeocoding = $form => {
  const $geocodeButton = $('button.geocode');
  const $locationInput = $('input[name="geocode-search"]');
  const $modalButton = $('.update-location.button');
  const $modal = $('#location-modal');

  let updatedAddress = null;
  let updatedPostalcode = null;
  let updatedCity = null;
  let updatedLocation = null;

  const onMapClick = (e, map) => {
    $geocodeButton.addClass('loading');
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const zoom = map.getZoom();

    geocodeString(lat + ',' + lng)
      .then(
        obj => {
          updatedAddress = obj.address.address;
          updatedPostalcode = obj.address.postal_code;
          updatedCity = obj.address.city;

          updatedLocation = { lat, lng };

          if (obj.formattedAddress) {
            $locationInput.val(obj.formattedAddress);
          }
          initMapFromLocation(obj.coordinates, onMapClick, zoom, false);
        },
        _ => error("Impossible de récupérer les informations d'adresse")
      )
      .then(_ => $geocodeButton.removeClass('loading'));
  };

  if (
    $geocodeButton &&
    $geocodeButton.length &&
    $locationInput &&
    $locationInput.length &&
    $modalButton &&
    $modalButton.length &&
    $modal &&
    $modal.length
  ) {
    // Handling geocoding

    $geocodeButton.off('click').on('click', evt => {
      evt.preventDefault();

      $geocodeButton.addClass('loading');
      geocodeString($locationInput.val())
        .then(
          response => {
            if (response.address.address) {
              updatedAddress = response.address.address;
            }

            if (response.address.postal_code) {
              updatedPostalcode = response.address.postal_code;
            }

            if (response.address.city) {
              updatedCity = response.address.city;
            }

            if (response.coordinates) {
              updatedLocation = response.coordinates;
            }

            initMapFromLocation(
              response.coordinates,
              onMapClick,
              undefined,
              false
            );
          },
          _ => error("Impossible de récupérer les informations d'adresse")
        )
        .then(_ => $geocodeButton.removeClass('loading'));
    });

    $modal.modal({
      onApprove: bt => {
        const $addressInput = $form.find('input[name="address.address"]');
        const $postalCodeInput = $form.find('input[name="address.postalCode"]');
        const $cityInput = $form.find('input[name="address.city"]');
        const $locationInput = $form.find('input[name="location"]');

        if ($addressInput && $addressInput.length) {
          $addressInput.val(updatedAddress);
        }

        if ($postalCodeInput && $postalCodeInput.length) {
          $postalCodeInput.val(updatedPostalcode);
        }

        if ($cityInput && $cityInput.length) {
          $cityInput.val(updatedCity);
        }

        if ($locationInput && $locationInput.length && updatedLocation) {
          $locationInput.val(`${updatedLocation.lat},${updatedLocation.lng}`);
        }

        enableEmptyFields($addressInput, $postalCodeInput, $cityInput);
      },
    });

    $modalButton.off('click').on('click', evt => {
      $modal.modal('show');
    });
  }

  const $gpsInput = $form.find('input[name="location"]');
  if ($gpsInput && $gpsInput.val() && $gpsInput.val().includes(',')) {
    var lat = $gpsInput.val().split(',')[0];
    var lng = $gpsInput.val().split(',')[1];

    const initMap = () =>
      initMapFromLocation(
        {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        },
        onMapClick,
        10,
        false
      );

    navigator.geolocation.getCurrentPosition(initMap, initMap);
  } else {
    const initEmptyMap = () => {
      initMapFromLocation(
        {
          lat: 43.768545,
          lng: 2.518912,
        },
        onMapClick,
        5,
        true
      );
    };

    const locationFound = position => {
      initMapFromLocation(
        {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        },
        onMapClick,
        undefined,
        true
      );
    };

    navigator.geolocation.getCurrentPosition(locationFound, initEmptyMap);
  }
};

function initMapFromLocation(loc, cb, zoom, noMarker, mapDivId) {
  const map = new google.maps.Map(document.getElementById(mapDivId || 'map'), {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    zoom: zoom || 12,
    center: loc,
  });

  if (cb) {
    map.addListener('click', e => cb(e, map));
  }

  if (noMarker) {
    return map;
  }
  return new google.maps.Marker({
    position: loc,
    map,
  });
}

export function createParticular() {
  create();

  const $switch = $('.ui.radio.checkbox.identity');
  $switch.checkbox('toggle');
}

export function create() {
  bindForm();

  // bind geocoding behavior
  const $companyForm = $('.companyForm');
  bindCreationGeocoding($companyForm);

  const $particularForm = $('.particularForm');
  bindCreationGeocoding($particularForm, true);

  // Enable dirty form
  $('form.ui.form').areYouSure();
}

export function edit() {
  bindForm();

  // bind geocoding behavior
  const $companyForm = $('.companyForm');
  const $particularForm = $('.particularForm');
  bindUpdateGeocoding($companyForm);

  // Enable dirty form
  $('form.ui.form').areYouSure();
}

export function importer() {
  $('.customer.import.button').on('click', () => {
    $('#importClientInput').trigger('click');
  });

  $('#importClientInput').on('change', evt => {
    const file = evt.target.files[0];
    const name = file ? file.name : "Envoyer l'Excel complété";
    $('.customer.import.button').html(`<i class="upload icon"></i>${name}`);
  });
}

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      width={columnWidth(width, 5)}
      label="Client"
    />,
    <Column
      key="client_code"
      dataKey="client_code"
      width={columnWidth(width, 2)}
      label="Code Client"
    />,
    <Column
      key="structure_type"
      dataKey="structure_type"
      width={columnWidth(width, 2)}
      label="Type"
    />,
    <Column
      key="postal_code"
      dataKey="postal_code"
      width={columnWidth(width, 2)}
      label="Code Postal"
    />,
    <Column
      key="city"
      dataKey="city"
      width={columnWidth(width, 2)}
      label="Ville"
    />,
    <Column
      key="contact_name"
      dataKey="contact_name"
      width={columnWidth(width, 2)}
      label="Contact"
    />,
    <Column
      key="contact_phone"
      dataKey="contact_phone"
      width={columnWidth(width, 2)}
      label="Telephone"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/customers/index.js